import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/forms/context/formContextProvider";
import {
	LOAN_TYPE_BUSINESS,
	LOAN_TYPE_BUSINESS_ALL,
	LOAN_TYPE_BUSINESS_WORKING_CAPITAL,
	LOAN_TYPE_BUSINESS_VEHICLE,
	LOAN_TYPE_BUSINESS_TRUCK,
	LOAN_TYPE_BUSINESS_EQUIPMENT,
	LOAN_TYPE_BUSINESS_COMMERCIAL_PROPERTY,
} from "@/lib/constants";
import { QuickFormMain } from "@/components/forms/quickFormMain";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const id = rootElement.id;
	const [loanType, setLoanType] = useState<string | undefined>(LOAN_TYPE_BUSINESS);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);

	useEffect(() => {
		const root_loanType = rootElement?.dataset.component?.toLowerCase() ?? "main";
		setSiteTitle(rootElement?.dataset.title ?? "Business Finance");

		switch (root_loanType) {
			case "capital":
				setLoanType(LOAN_TYPE_BUSINESS_WORKING_CAPITAL);
				break;
			case "vehicle":
				setLoanType(LOAN_TYPE_BUSINESS_VEHICLE);
				break;
			case "truck":
				setLoanType(LOAN_TYPE_BUSINESS_TRUCK);
				break;
			case "equipment":
				setLoanType(LOAN_TYPE_BUSINESS_EQUIPMENT);
				break;
			case "property":
				setLoanType(LOAN_TYPE_BUSINESS_COMMERCIAL_PROPERTY);
				break;
			default:
				setLoanType(LOAN_TYPE_BUSINESS_ALL);
				break;
		}
	}, [rootElement, setSiteTitle, setLoanType]);

	const renderComponent = () => {
		return (
			<QuickFormMain rootElement={rootElement} loanTypes={loanType} siteTitle={siteTitle} />
		);
	};

	return (
		<FormContextProvider id={id}>
			<QueryClientProvider client={queryClient}>
				{siteTitle ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
